import {TypedJSON} from 'typedjson';

import {Device} from '@/model/network/device/Device';
import {DeviceEthernet} from '@/model/network/device/DeviceEthernet';
import {DeviceType} from '@/model/network/device/DeviceType';

export class DeviceFactory {

  public static CreateDevice(device: any): Device {

    if (!device.type) {
      return new TypedJSON(Device).parse(device)!;
    }

    switch (device.type) {
      case DeviceType.Ethernet:
        return new TypedJSON(DeviceEthernet).parse(device)!;

      default:
        return new TypedJSON(Device).parse(device)!;
    }
  }
}
